/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_EVENT_TEMPLATES,
  GET_EVENT_TEMPLATES_SUCCESS,
  GET_EVENT_TEMPLATES_ERROR,
  CLEAR_EVENT_TEMPLATES,
  UPSERT_EVENT_TEMPLATE,
  UPSERT_EVENT_TEMPLATE_SUCCESS,
  UPSERT_EVENT_TEMPLATE_ERROR,
  SET_EVENT_TEMPLATE_SCOPE,
  CLEAR_EVENT_TEMPLATE_SCOPE,
} from 'src/actions/eventTemplatesActions';

// CON-1487 Phase E — Event Templates slice.
//
// Kept tiny: the list view holds 6 resolved rows (service returns
// `results: [{ templateType, row, source }]`) and a saving flag for the
// detail screen. Detail screen pulls its current template from the
// results array by templateType rather than maintaining a separate
// detail slot — one round-trip, one shape.

const initialState = {
  loading: false,
  saving: false,
  scopeType: null,
  scopeId: null,
  results: [],
};

const eventTemplatesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EVENT_TEMPLATES: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_EVENT_TEMPLATES_SUCCESS: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.scopeType = payload?.scopeType ?? null;
        draft.scopeId = payload?.scopeId ?? null;
        draft.results = Array.isArray(payload?.results) ? payload.results : [];
      });
    }

    case GET_EVENT_TEMPLATES_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_EVENT_TEMPLATES: {
      return produce(state, () => initialState);
    }

    case UPSERT_EVENT_TEMPLATE: {
      return produce(state, (draft) => {
        draft.saving = true;
      });
    }

    case UPSERT_EVENT_TEMPLATE_SUCCESS: {
      return produce(state, (draft) => {
        draft.saving = false;
        // Merge the returned row back into results so the list view
        // picks up the new source = 'user_partyType' / 'user_party'
        // without a refetch.
        const row = payload?.row;
        if (row?.templateType) {
          const idx = draft.results.findIndex((r) => r.templateType === row.templateType);
          if (idx !== -1) {
            draft.results[idx] = {
              ...draft.results[idx],
              row,
              source: row.partyId
                ? 'user_party'
                : 'user_partyType',
            };
          }
        }
      });
    }

    case UPSERT_EVENT_TEMPLATE_ERROR: {
      return produce(state, (draft) => {
        draft.saving = false;
      });
    }

    case SET_EVENT_TEMPLATE_SCOPE: {
      return produce(state, (draft) => {
        draft.scopeType = payload?.scopeType ?? null;
        draft.scopeId = payload?.scopeId ?? null;
      });
    }

    case CLEAR_EVENT_TEMPLATE_SCOPE: {
      return produce(state, (draft) => {
        draft.scopeType = null;
        draft.scopeId = null;
      });
    }

    default:
      return state;
  }
};

export default eventTemplatesReducer;
